import { ShowDepartmentRequestSchema, ShowDepartmentResponseSchema } from './show-department.schema';
/**
 * Show Department Endpoint Contract
 * Retrieves a specific department by ID
 */ export const showDepartmentContract = {
    method: 'GET',
    path: '/api/v2/department/:id',
    description: 'Retrieve a specific department by ID',
    requestSchema: ShowDepartmentRequestSchema,
    responseSchema: ShowDepartmentResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Department not found'
        }
    }
};

//# sourceMappingURL=show-department.contract.js.map